import Quad from './quad';
import Vector3 from './vector3';
import THREE from 'three';

export default class BoxGeometry extends THREE.BoxGeometry {
	constructor(width, height, depth, widthSegments, heightSegments, depthSegments) {
		super(width, height, depth, widthSegments, heightSegments, depthSegments);
		this.quads = [];
		this.buildQuads = function() {
			// manually first

			// 0,2,1
			// 2,3,1
			// left
			this.quads.push(new Quad(
				this.vertices[0],
				this.vertices[1],
				this.vertices[3],
				this.vertices[2]
			));

			// 4,6,5
			// 6,7,5
			// right
			this.quads.push(new Quad(
				this.vertices[4],
				this.vertices[5],
				this.vertices[7],
				this.vertices[6]
			));

			// 4,5,1
			// 5,0,1
			// top
			this.quads.push(new Quad(
				this.vertices[4],
				this.vertices[1],
				this.vertices[0],
				this.vertices[5]
			));

			// 7,6,2
			// 6,3,2
			// bottom
			this.quads.push(new Quad(
				this.vertices[7],
				this.vertices[2],
				this.vertices[3],
				this.vertices[6]
			));

			// 5,7,0
			// 7,2,0
			// front
			this.quads.push(new Quad(
				this.vertices[5],
				this.vertices[0],
				this.vertices[2],
				this.vertices[7]
			));

			// 1,3,4
			// 3,6,4
			// back
			this.quads.push(new Quad(
				this.vertices[1],
				this.vertices[4],
				this.vertices[6],
				this.vertices[3]
			));
		};

		this.buildQuads();
	}

	scale(_mod, scale2) {
		var params = this.parameters;

		var modHelper = ['width', 'height', 'depth'];

		var scalePossible = true;

		// quick fix for y
		scale2.y *= -1;

		if ((params[modHelper[_mod.x]] + scale2.x * 2) < 5
			|| (params[modHelper[_mod.y]] + scale2.y * 2) < 5) {
			scalePossible = false;
		}

		// console.log(params[modHelper[_mod.y]],modHelper[_mod.y],(_mod.yD*scale2.y*2),scalePossible)

		var scaleVectors = [];

		this.vertices.forEach(function(_v, index) {
			var scaleVector = scale2.clone();
			var objVector = new Vector3().copy(_v).toVector2(_mod);
			scaleVector.x *= (objVector.x > 0) ? 1 : -1;
			scaleVector.y *= (objVector.y > 0) ? 1 : -1;
			scaleVectors.push(scaleVector);
			/*
			if(
				Math.abs(objVector.x+scaleVector.x)<5 ||
				Math.abs(objVector.y+scaleVector.y)<5
			) {
				scalePossible = false;
			}
			*/
		});

		if (scalePossible) {
			params[modHelper[_mod.x]] += (scale2.x) * 2;
			params[modHelper[_mod.y]] += (scale2.y) * 2;
			this.parameters = params;
		}

		var that = this;

		if (scalePossible) {
			this.vertices.forEach(function(_v, index) {
				_v.add(scaleVectors[index].toVector3(_mod));
				that.verticesNeedUpdate = true;
			});
		}

		return scalePossible;
	}

	clone(params) {
		if (!params)
			params = this.parameters;

		var geometry = new BoxGeometry(
			params.width, params.height, params.depth,
			params.widthSegments, params.heightSegments, params.depthSegments
		);

		return geometry;
	}
}

